import { CaixaProps } from "../../components/Estrutura/Caixa";

export const amplificadores: CaixaProps[] = [
  {
    nome: "Marshall Valvestate VS100",
    descricao:
      "Amplificador Marshall de guitarra valvulado com timbre clássico e 2 canais, potência de 100W, ideal para diversos estilos musicais. Controles clean, overdrive e equalização.",
    img: "/assets/Estudio/IMG_8678.jpg",
  },
  {
    nome: "Marshall Valvestate VS65R",
    descricao:
      "Amplificador Marshall de guitarra valvulado com 2 canais de 65W, equipado com um alto-falante de 12 polegadas, loop de efeito e reverb.",
    img: "/assets/Estudio/IMG_8689.jpg",
  },
  {
    nome: "Fender Princeton Chorus",
    descricao:
      "Amplificador Fender de guitarra Combo com 2 canais, potência de 65W, alto-falante de 12 polegadas, reverb digital e chorus estéreo. Perfeito para ensaios e gravações, com timbre versátil.",
    img: "/assets/Estudio/IMG_8690.jpg",
  },
  {
    nome: "Peavey KB/A 100",
    descricao:
      'Amplificador Peavey para teclado, com potência de saída de 65W, 3 canais, reverb digital, built-in effects, falante de 15". Som perfeito para ensaios, gravações e shows ao vivo.',
    img: "/assets/Estudio/IMG_8687.jpg",
  },
  {
    nome: 'Fender BXR 100 15"',
    descricao:
      'Amplificador usado para baixo com 100W e driver de 15". Possui preamp versátil com 2 entradas, 3 bandas de equalização e diversas conexões, além do sistema DELTACOMP™ que protege contra distorção. Ideal para baixos com pickups ativos ou passivos, proporcionando desempenho robusto e sonoridade consistente.',
    img: "/assets/Estudio/IMG_8684.jpg",
  },
  {
    nome: "Meteoro Nitrous 150B",
    descricao:
      "Amplificador Meteoro Combo de baixo com 1 canal, potência de saída de 150W, sensibilidade de 100mV e alta impedânicia. Controles de volume, Hi Middle, Lo Middle, Treble e Bass, saída para caixa externa e linha de conexão para mesa de som.",
    img: "/assets/Estudio/IMG_8691.jpg",
  },
  {
    nome: "Peavey TKO 115S",
    descricao:
      'Amplificador Peavey de baixo, modelo clássico, super potente e com timbre excelente. Falante Sheffield de 15", equalizador gráfico de 7 bandas, entrada para efeitos, saída para fones, pré-amp e entrada passiva/ativa. Ideal para ensaios e gravações.',
    img: "/assets/Estudio/IMG_8682.jpg",
  },

  {
    nome: "Meteoro Nitrous 160G",
    descricao:
      "Amplificador Meteoro Combo de guitarra com 2 canais, potência de 160W, alto-falante de 12 polegadas, com reverb digital e chorus estéreo.",
    img: "/assets/Estudio/IMG_8681.jpg",
  },
];
